<template>
<div class="animated fadeIn">
  <b-card no-body>
    <b-card-body>
      <strong>Selected rooms</strong>
      <b-row>
        <b-col lg="12">
          <v-client-table :data="rooms" :columns="roomColumns" :options="roomOptions" :theme="theme" id="reservationRoomsTable" ref="reservationRoomsTable">
            <template slot="actions" slot-scope="data">
              <b-button class="mr-1" size="sm" variant="primary" @click="deleteRoom(data.row)">Delete</b-button>
            </template>
            <span slot="has_toilet" slot-scope="data">{{data.row.has_toilet ? data.row.toilet_type : 'No'}}</span>
            <span slot="has_ac" slot-scope="data">{{data.row.has_ac ? 'Yes' : 'No'}}</span>
          </v-client-table>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>

  <b-card no-body>
    <b-card-body>
    <b-button-toolbar class="pull-right">
      <b-btn variant="primary" @click="holdForPayment(false)" class="mr-1" :disabled="rooms.length == 0">Hold for Bhent</b-btn>
    </b-button-toolbar>
    </b-card-body>
  </b-card>

  <b-card no-body>
    <b-card-body>
      <strong>Available rooms</strong>
      <v-client-table :data="buildings" :columns="columns" :options="options" :theme="theme" id="buildingDataTable">
        <template slot="child_row" slot-scope="data">
          <floor-search :floors="data.row.floors" @selected="addRoom"></floor-search>
        </template>
      </v-client-table>
    </b-card-body>
  </b-card>

</div>
</template>

<script>
import {
  mapState,
} from 'vuex'
import FloorSearch from './FloorSearch'

export default {
  name: "MultipleManualMatching",
  props: {
    reservations: Array
  },
  components: {
    FloorSearch
  },
  computed: mapState({
    buildings: state => state.reservations.availableBuildings,
    availRooms: state => state.reservations.availableRooms,
  }),
  data() {
    return {
      rooms: [],
      columns: [
        'name',
        'avail_rooms',
      ],
      options: {
        headings: {
          name: 'Name',
          avail_rooms: 'Available Rooms',
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      roomColumns: [
        'floor.building.name',
        'floor.floor_number',
        'room_number',
        'price',
        'number_of_beds',
        'max_occupiers',
        'has_toilet',
        'has_ac',
        'actions'
      ],
      roomOptions: {
        headings: {
          'floor.building.name': 'Building',
          'floor.floor_number': 'Floor',
          room_number: 'Room Number',
          price: 'Bhent',
          number_of_beds: "Beds",
          max_occupiers: "Max Occupiers",
          has_toilet: "Toilet",
          has_ac: "AC",
          actions: 'Actions'
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      theme: 'bootstrap4',
    }
  },
  methods: {
    addRoom(room) {
      this.rooms.push(room)
      let availableRooms = _.filter(this.availRooms, item => item.id != room.id)
      this.$store.commit('reservations/setAvailableRooms', availableRooms)
    },
    deleteRoom(room) {
      this.rooms = _.filter(this.rooms, item => item.id != room.id)
      let availableRooms = _.concat(this.availRooms, room)
      this.$store.commit('reservations/setAvailableRooms', availableRooms)
    },
    holdForPayment(isPayment) {
      let selectedIds = _.map(this.rooms, room => room.id)
      let reservationIds = _.map(this.reservations, reservation => reservation.id)
      this.$store.dispatch('reservations/setMultipleManualRooms', {reservation_ids: reservationIds, room_ids: selectedIds})
      .then(() => {
        this.$emit('submit')
        this.showSuccessMsg()
      })
      .catch((error) => {
        if (error.response.status == 400) {
          this.showErrorMsg({
            message: error.response.data.message
          })
        } else {
          this.showErrorMsg()
        }
      })
    }
  },
  created() {
    let startDate = '2100-31-12'
    let endDate = '1970-01-01'
    _.each(this.reservations, (reservation) => {
      let arrival = this.formatDate(reservation.arrival_date)
      let departure = this.formatDate(reservation.departure_date)
      if (startDate > arrival) {
        startDate = arrival
      }
      if (endDate < departure) {
        endDate = departure
      }
    })
    this.$store.dispatch('reservations/searchAvailableRooms', {arrival: startDate, departure: endDate})
  }
}
</script>
